import { render, staticRenderFns } from "./chatRule.vue?vue&type=template&id=045105b5&scoped=true&"
import script from "./chatRule.vue?vue&type=script&lang=js&"
export * from "./chatRule.vue?vue&type=script&lang=js&"
import style0 from "./chatRule.vue?vue&type=style&index=0&id=045105b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045105b5",
  null
  
)

export default component.exports